import FieldEditor from "editor/FieldEditor";

class FieldEditorTags extends FieldEditor {

    create() {
        const $input = this.$input = (eotwJSXFactory('input', {type: "text", class: "admin-form__input", 'data-optional': true, 'data-no-validate': true}));
        const $btn = this.$btn = (eotwJSXFactory('button', {type: "button", class: "admin-btn admin-btn--primary admin-btn--straight-left admin-btn--large-text admin-btn--no-margin admin-btn--padding-inline"}, ["Add"]));
        const $tags = this.$tags = (eotwJSXFactory('div', {class: "js-tag-list"}));
        const me = this;
        this.values = [];

        this.$element.html((
            eotwJSXFactory('div', null, [
                eotwJSXFactory('div', {class: "admin-form__row admin-form__row--flex admin-form__row--no-wrap admin-form__row--margin-bottom-10"}, [
                    $input,
                    $btn
                ]),
                $tags
            ])
        ));

        $btn.on('click', () => {
            this.addValues();
            return false;
        });

        $input.on('keypress', (e) => {
            if (e.key === 'Enter') {
                this.addValues();
                return false;
            }
        });

        $tags.on('click', '.js-remove', function () {
            me.removeValue($(this).parent().find('.js-value').text());
        });

    }

    splitValues(text) {
        return text.trim().length <= 0 ? [] : text.split(",").map((value) => {
            return value.trim();
        }).filter((value) => {
            return value.length > 0;
        });
    }

    destroy() {
        super.destroy();

        this.$element.html('');
    }

    removeValue(value) {
        let index = this.values.indexOf(value);
        if (index !== -1) {
            this.values.splice(index, 1);
        }

        this.updateTags();
        this.emit('change');
    }

    addValues() {
        this.values = FieldEditorTags.normalise_array(this.values.concat(this.splitValues(this.$input.val())));
        this.$input.val('');

        this.updateTags();
        this.emit('change');
    }

    getValue() {
        return this.values;
    }

    setValue(value) {
        this.values = FieldEditorTags.normalise_array(value);
        this.$input.val('');

        this.updateTags();
        this.emit('change');
    }

    updateTags() {
        this.$tags.html(this.values.map((value) => (
            eotwJSXFactory('div', {class: "admin-form-tag"}, [
                eotwJSXFactory('span', {class: "js-value"}, [value]),
                eotwJSXFactory('button', {type: "button", class: "admin-form-tag__btn admin-form-tag__btn--remove js-remove"}).html("<svg><use xmlns:xlink=\"http://www.w3.org/1999/xlink\" xlink:href=\"" + window.CONFIG.adminBuildUrl + "base/icons.svg#delete\"></use></svg>")
            ])
        )));
    }

    static normalise_array(values) {
        if (!Array.isArray(values)) {
            values = [values];
        }

        values = values.map((value) => value.trim()).filter((value) => value.length > 0);

        let seenValues = {};

        values = values.filter((value) => {
            if ('undefined' !== typeof seenValues[value.toLowerCase()]) return;
            seenValues[value.toLowerCase()] = true;
            return true;
        });

        return values;
    }
}

FieldEditor.register_editor("tags", FieldEditorTags);

export default FieldEditorTags;
